
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule2DataInfoType } from '@/types/Application/CaseManagement/PDF';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule2 extends Vue {

    @Prop({required:true})
    result!: any;

    dataReady = false;
    modReqInfo = {} as schedule2DataInfoType; 
   
    mounted(){
        this.dataReady = false;        
        this.extractInfo();       
        this.dataReady = true;
    }

    public extractInfo(){        
        this.modReqInfo = this.getWaiveModifyRequirementsInfo();
    }

    public getWaiveModifyRequirementsInfo(){
        let waiveModifyRequirementsInfo = {} as schedule2DataInfoType;
        
        if(this.result?.changingOrCancellingAServiceOrNoticeSurvey){
            const chgSurvey = this.result.changingOrCancellingAServiceOrNoticeSurvey;
            const namesOfNeedToBeServedCondition = chgSurvey.namesOfNeedToBeServed? chgSurvey.namesOfNeedToBeServed?.split(/[;,]+/).map(item => {return item.trim();}):[]

            waiveModifyRequirementsInfo.isWaiveOrModify =  (chgSurvey.changeOrCancelRequirementForService =='y');
            waiveModifyRequirementsInfo.isAltMethodService = (chgSurvey.anotherMethodOfService == 'y');
            waiveModifyRequirementsInfo.changetype = chgSurvey.changeOrCancelRequirementForService =='y' ? chgSurvey.changetype : '';
            waiveModifyRequirementsInfo.orderChangesDetail = (waiveModifyRequirementsInfo.isWaiveOrModify  && waiveModifyRequirementsInfo.changetype == "changemodify") ? chgSurvey.orderChangesDetail: '';            
            waiveModifyRequirementsInfo.waiveChangeRequirementList = (waiveModifyRequirementsInfo.isWaiveOrModify && waiveModifyRequirementsInfo.changetype == 'changewaive') ? chgSurvey.documentList: [];
            waiveModifyRequirementsInfo.waiveChangeRequirementComment = (waiveModifyRequirementsInfo.isWaiveOrModify && waiveModifyRequirementsInfo.changetype == 'changewaive') ? chgSurvey.documentListComment:'';
            waiveModifyRequirementsInfo.applicationFacts = (waiveModifyRequirementsInfo.isWaiveOrModify && waiveModifyRequirementsInfo.changetype == 'changewaive') ? chgSurvey.applicationFacts:'';

            waiveModifyRequirementsInfo.nameOfPersonToBeServed = waiveModifyRequirementsInfo.isAltMethodService?namesOfNeedToBeServedCondition:[];
            waiveModifyRequirementsInfo.altMethodApplicationFacts = waiveModifyRequirementsInfo.isAltMethodService? chgSurvey.applicationFactsAltMethod:'';
            waiveModifyRequirementsInfo.altMethodServingDetails = waiveModifyRequirementsInfo.isAltMethodService? chgSurvey.altMethodServingDetails:'';
            waiveModifyRequirementsInfo.isalternativeServiceReasonUnknown =  waiveModifyRequirementsInfo.isAltMethodService? chgSurvey.alternativeServiceReason == "unknown": false;
            waiveModifyRequirementsInfo.isalternativeServiceReasonNotReachable =  waiveModifyRequirementsInfo.isAltMethodService? chgSurvey.alternativeServiceReason == "outofreach": false;
            waiveModifyRequirementsInfo.alternativeServiceReasonDetails = waiveModifyRequirementsInfo.isAltMethodService? chgSurvey.alternativeServiceReasonDetails:'';
            waiveModifyRequirementsInfo.personwhereabouts = waiveModifyRequirementsInfo.isAltMethodService? chgSurvey.personwhereabouts:'';
            waiveModifyRequirementsInfo.alternativeorderservice = waiveModifyRequirementsInfo.isAltMethodService? chgSurvey.alternativeorderservice:'';
            waiveModifyRequirementsInfo.alternativemailType = chgSurvey.alternativemailType ?  chgSurvey.alternativemailType : '';
            waiveModifyRequirementsInfo.alternativemailAddress = chgSurvey.alternativemailAddress ?  chgSurvey.alternativemailAddress : '';
            waiveModifyRequirementsInfo.alternativemailCity = chgSurvey.alternativemailCity ?  chgSurvey.alternativemailCity : '';
            waiveModifyRequirementsInfo.alternativeEmail = chgSurvey.alternativeEmail ?  chgSurvey.alternativeEmail : '';
            waiveModifyRequirementsInfo.alternativeText = chgSurvey.alternativeText ?  chgSurvey.alternativeText : '';
            waiveModifyRequirementsInfo.alternativeOther = chgSurvey.alternativeOther;
            waiveModifyRequirementsInfo.alternativeRelativeName = chgSurvey.alternativeRelativeName ?  chgSurvey.alternativeRelativeName : '';
            waiveModifyRequirementsInfo.alternativeRelatveRelationship = chgSurvey.alternativeRelatveRelationship ?  chgSurvey.alternativeRelatveRelationship : '';
            waiveModifyRequirementsInfo.alternativeSocialPlatform = chgSurvey.alternativeSocialPlatform ?  chgSurvey.alternativeSocialPlatform : '';
            waiveModifyRequirementsInfo.alternativeSocialPlatformId = chgSurvey.alternativeSocialPlatformId ?  chgSurvey.alternativeSocialPlatformId : '';
            
            waiveModifyRequirementsInfo.modifyChangeRequirementList = (waiveModifyRequirementsInfo.isWaiveOrModify && waiveModifyRequirementsInfo.changetype == 'changemodify') ? chgSurvey.documentList: [];
            waiveModifyRequirementsInfo.modifyMethodApplicationFacts = (waiveModifyRequirementsInfo.isWaiveOrModify && waiveModifyRequirementsInfo.changetype == 'changemodify') ? chgSurvey.applicationFacts:'';
            waiveModifyRequirementsInfo.modifyChangeRequirementComment = (waiveModifyRequirementsInfo.isWaiveOrModify && waiveModifyRequirementsInfo.changetype == 'changemodify') ? chgSurvey.documentListComment:'';
            //waiveModifyRequirementsInfo.waiveMethodApplicationFacts = (waiveModifyRequirementsInfo.isAltMethodService && waiveModifyRequirementsInfo.changetype == 'changewaive') ? chgSurvey.applicationFacts:'';



            let altMetList = chgSurvey.documentListForAltMethod;
            if(altMetList){
                altMetList = altMetList.replace(/\n/g,'<br>');
                altMetList = altMetList.replace(/;/g, '<br>');
                altMetList = altMetList.replace(/,/g, '<br>');
            }
            waiveModifyRequirementsInfo.altMethodDocList  = waiveModifyRequirementsInfo.isAltMethodService? altMetList:'';
          }
        
        
        return waiveModifyRequirementsInfo;
    }
}
